var _defs, _path, _path2, _path3, _circle, _use, _use2, _use3, _use4, _path4, _path5, _use5, _use6, _use7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-gd",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "#fcd116",
    d: "M0-1v1h.5",
    transform: "rotate(18 0 -1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(216)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(288)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#007a5e",
    d: "M67.2 67.2h505.6v345.6H67.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M67.2 67.3h505.6L67.2 412.9h505.6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 319.9,
    cy: 240.1,
    r: 57.6,
    fill: "#ce1126"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    transform: "matrix(52.8 0 0 52.8 320 240)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    x: -100,
    transform: "translate(-30.3)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    id: "d",
    width: "100%",
    height: "100%",
    transform: "matrix(31.2 0 0 31.2 320 33.6)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    x: 100,
    transform: "translate(30.3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M102.3 240.7a80.4 80.4 0 0 0 33.5 33.2 111 111 0 0 0-11.3-45l-22.2 11.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M90.1 194.7c10.4 21.7-27.1 73.7 35.5 85.9a63.2 63.2 0 0 1-10.9-41.9 70 70 0 0 1 32.5 30.8c16.4-59.5-42-55.8-57.1-74.8z"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    x: -100,
    transform: "translate(-30.3 414.6)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    transform: "matrix(31.2 0 0 31.2 320 448.2)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    x: 100,
    transform: "translate(30.3 414.6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGd);
export default __webpack_public_path__ + "static/media/gd.9357b33dc4ff2614d2dd34386eff33ad.svg";
export { ForwardRef as ReactComponent };